module.exports = __webpack_public_path__ + "img/caret-down.9cbcc982.svg";